export const primaryBtnVariant = {
  initial: { scale: 1, background: "#93A267" },
  click: { scale: 0.99, background: "#7d8c56" },
  transition: { duration: 0.3, ease: "ease-in-out" },
};

export const ScaleOnClickVariant = {
  initial: { scale: 1 },
  click: { scale: 0.99 },
  transition: { duration: 0.2, ease: "ease-in-out" },
};

export const cartTextChangeVariant = {
  initial: { opacity: 1 },
  animate: { opacity: 0 },
  transition: { duration: 0.3, ease: "ease-in-out" },
};
